import { createBrowserRouter, Navigate } from "react-router-dom";
import { Shell } from "@/components/shell/Shell";
import { AuthGate } from "@/components/AuthGate";

import { DashboardScreen } from "@/features/dashboard/DashboardScreen";
import { ApprovalsScreen } from "@/features/approvals/ApprovalsScreen";
import { JobDetailScreen } from "@/features/job/JobDetailScreen";
import { ReplayScreen } from "@/features/job/ReplayScreen";
import { CredentialsScreen } from "@/features/credentials/CredentialsScreen";
import { ReferenceDocsScreen } from "@/features/reference-docs/ReferenceDocsScreen";
import { WizardScreen } from "@/features/wizard/WizardScreen";
import { WorkflowsScreen } from "@/features/workflows/WorkflowsScreen";
import { AuditScreen } from "@/features/audit/AuditScreen";
import { ForensicExportScreen } from "@/features/audit/ForensicExportScreen";
import { PermissionDeniedScreen } from "@/components/PermissionDeniedScreen";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthGate>
        <Shell />
      </AuthGate>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <DashboardScreen /> },
      { path: "approvals", element: <ApprovalsScreen /> },
      { path: "jobs/:jobId", element: <JobDetailScreen /> },
      { path: "jobs/:jobId/replay", element: <ReplayScreen /> },
      { path: "credentials", element: <CredentialsScreen /> },
      { path: "reference-docs", element: <ReferenceDocsScreen /> },
      { path: "workflows", element: <WorkflowsScreen /> },
      { path: "workflows/new", element: <WizardScreen /> },
      { path: "workflows/:workflowId/edit", element: <WizardScreen /> },
      { path: "audit", element: <AuditScreen /> },
      { path: "audit/exports", element: <ForensicExportScreen /> },
      { path: "403", element: <PermissionDeniedScreen /> },
      { path: "*", element: <Navigate to="/dashboard" replace /> },
    ],
  },
]);
